
import {
    ApiManager,
    sessionService,
    SessionManager,
    LoggerUtility,
    EnumUtility,
    UtilityLibrary
} from '../components/ComponentsLibrary';

class CaseDataService {
    static masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;
    constructor() {
        this.caseUniqueID = "caseNumber";
    }

    getCaseDataFromSessionByID(caseID) {
        try {
            return SessionManager.GetDataFromSessionByValue(caseID, this.caseUniqueID, SessionManager.CaseInformationKey);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDataFromSessionByID", {});
        }
    };

    async getCaseInfoFromApiByID(caseID) {
        try {
            const params = {
                caseNumber: caseID,
                masterServerDBSchema: CaseDataService.masterServerDBSchema 
            };
            const caseApiData = await ApiManager.GetCaseDataFromApiByID(params);
            if (caseApiData && caseApiData.length > 0) {
                caseApiData.forEach(item => {
                    item.lastViewed = new Date().toISOString();
                });
                SessionManager.AddOrUpdateParent(caseApiData, this.caseUniqueID, SessionManager.CaseInformationKey);
                return caseApiData[0];
            }
            else {
                return null;
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseInfoFromApiByID", {});
        }

    };


    getCaseDocsFromSessionByCaseID(caseID) {
        try {
            const caseSessionData = SessionManager.GetChildDataFromSessionByParentID(caseID, this.caseUniqueID, 'caseDocs', SessionManager.CaseInformationKey);
            return caseSessionData;
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDocsFromSessionByCaseID", {});
        }
    };

    async getCaseDocumentsFromApiByCaseID(caseID) {
        try {
            const sessionLoginUser = sessionService.LoginUserInfo;
            const params = {
                documentID: 0,
                caseNumber: caseID,
                systemTimeZoneName: sessionLoginUser?.timeZone
            }
            
            const caseDocsApiData = await ApiManager.GetCaseDocsFromApiByCaseID(params);
            
            if (caseDocsApiData && caseDocsApiData.length > 0) {
                SessionManager.AddOrUpdateChildToParent(this.caseUniqueID, caseID, 'caseDocs', 'batchDocumentID', caseDocsApiData, SessionManager.CaseInformationKey);
                return caseDocsApiData;
            }
            else {
                return null;
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDocumentsFromApiByCaseID", {});
        }
    };

    async getCaseDocumentsFromApiByCaseWorkflowID(caseWorkflowID) {
        try {
            const sessionLoginUser = sessionService.LoginUserInfo;
            const params = {
                caseWorkflowID: caseWorkflowID,
                systemTimeZoneName: sessionLoginUser?.timeZone
            }
            
            const caseDocsApiData = await ApiManager.GetCaseDocsFromApiByCaseWorkflowID(params);
            
            if (caseDocsApiData && caseDocsApiData.length > 0) {
                SessionManager.AddOrUpdateChildToParent(this.caseUniqueID, caseWorkflowID, 'caseDocs', 'batchDocumentID', caseDocsApiData, SessionManager.CaseInformationKey);
                return caseDocsApiData;
            }
            else {
                return null;
            }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDocumentsFromApiByCaseWorkflowID", {});
        }
    };

    async getCaseDocsByCaseID(caseID) {
        try {

            const caseDocsSessionData = this.getCaseDocsFromSessionByCaseID(caseID);
            if (caseDocsSessionData) {
                return caseDocsSessionData;
            }
            else {
                return await this.getCaseDocumentsFromApiByCaseID(caseID);
            }

        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCaseDocsByCaseID", {});
        }
    };

}

const caseDataService = new CaseDataService();

export default caseDataService;